import React from "react";
import { Col, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import SoldOutOverlay from "./SoldOutOverlay";
import Cart from "assets/activity/cartIcon.png";
import { convertTimeStamp } from "utility/functions/convertTimestamp";

const TICKET_TYPE_EXTERNAL = 16;

const ActivityTicketInfo = ({ item, handleClickImg, isMobile, openCharts }) => {
  const { Paragraph } = Typography;
  const isExternalTicket = Number(item?.type) === TICKET_TYPE_EXTERNAL;
  const actionIconClassName =
    "flex items-center justify-center border-0 text-black cursor-pointer rounded-md mobile:rounded-[4px] tablet:w-10 tablet:h-10 tablet-portrait:w-10 tablet-portrait:h-10 desktop:w-10 desktop:h-10 mobile:w-[28px] mobile:h-[28px] bg-white absolute tablet:top-3 tablet:right-5 tablet-portrait:top-3 tablet-portrait:right-5 desktop:top-3 desktop:right-5 mobile:top-2 mobile:right-2 tablet:scale-90 tablet-portrait:scale-90 hover:rounded-xl transition-all duration-100 ease-in-out z-1";
  const ticketTimeText = isExternalTicket
    ? "時間細節以外部連結為主"
    : `${convertTimeStamp(
        item.startDateTime,
        "MM/DD ddd - HH:mm"
      )}（opens at ${convertTimeStamp(item.admissionStartDateTime, "HH:mm")}）`;

  return (
    <Col
      key={item.id}
      lg={{ span: 8 }}
      md={{ span: 8 }}
      sm={{ span: 12 }}
      xs={{ span: 12 }}
      className="cursor-pointer transition ease-in-out delay-100 duration-200 mb-10 mobile:mb-8"
    >
      <div className="relative">
        <picture
          className="block hover:opacity-75 transition-all duration-200 ease-in-out"
          key={item.id}
          onClick={() => handleClickImg(item)}
        >
          <source media="(max-width: 520px)" srcSet={item.mobile_url} />
          <img
            src={item.cover}
            alt=""
            className="w-full aspect-square object-cover mobile:rounded-[4px] tablet:rounded-2xl tablet-portrait:rounded-2xl desktop:rounded-3xl"
          />
        </picture>

        {/* 售完顯示樣式 */}
        {item.remainQuantity === 0 && <SoldOutOverlay isMobile={isMobile} />}

        {/* 剩餘數量 !== 0時，顯示購物車icon */}
        {item.remainQuantity !== 0 && (
          <>
            {isExternalTicket ? (
              <button
                type="button"
                className={actionIconClassName}
                onClick={() => openCharts(item)}
                aria-label="前往外部連結"
              >
                <ArrowRightOutlined className="text-base mobile:text-sm" />
              </button>
            ) : (
              <button
                type="button"
                className={actionIconClassName}
                onClick={() => openCharts(item)}
                aria-label="加入購物車"
              >
                <img
                  src={Cart}
                  className="w-5 h-5 mobile:w-4 mobile:h-4 object-contain scale-150"
                  alt=""
                />
              </button>
            )}
          </>
        )}

        {/* 價格標籤 */}
        <div
          className={`bg-white text-black p-2 rounded-3xl absolute tablet:top-4 tablet:left-6 tablet-portrait:top-4 tablet-portrait:left-6 desktop:top-4 desktop:left-6 mobile:top-2 mobile:left-2 mobile:px-[10px] mobile:py-0 mobile:h-[28px] mobile:text-[11px] mobile:leading-none items-center justify-center z-1 ${
            item.remainQuantity === 0 ? "hidden" : "flex"
          }`}
        >
          NT＄{item.price}
        </div>
      </div>

      {/* 票券資訊 */}
      <div className="text-left mt-3 mb-2" onClick={() => handleClickImg(item)}>
        <Paragraph
          ellipsis={true}
          className="text-SKF-G-002 mobile:mt-2 mt-0 text-base leading-6 mobile:text-[13px] mobile:leading-[18px] m-0"
        >
          {ticketTimeText}
        </Paragraph>
        <Paragraph
          ellipsis={isMobile ? false : true}
          className="m-0 text-white font-semibold text-lg leading-7 mobile:text-[15px] mobile:leading-[21px] mobile:mt-1"
        >
          {item.title}
        </Paragraph>
      </div>
    </Col>
  );
};

export default ActivityTicketInfo;
